export class VRTooltip {
  static defaultOptions = {
    position: 'top',
    strokeWidth: 0,
    corner: 4,
    label: '',
    fontSize: 14,
    color: 'white',
    textColor: '#333',
    tip: {
      type: 'arrow',
      width: 10,
      height: 10
    }
  };

  constructor (options) {
    this.options = $.extend({}, VRTooltip.defaultOptions, options);
    if (this.options.position === undefined) {
      this.options.position = 'top';
    }
    this.div = $('<div class="ca-vr_tooltip"></div>');
    this.div.addClass('ca-vr_tooltip_' + this.options.position);

    // Label
    this.tooltipLabel = $('<div class="ca-vr_tooltip_label"></div>');
    this.tooltipLabel.css('font-size', this.options.fontSize + 'px');
    this.tooltipLabel.css('line-height', this.options.fontSize + 'px');
    this.tooltipLabel.css('color', this.options.textColor);
    this.div.append(this.tooltipLabel);

    // Bg
    this.tooltipBg = $(
      '<svg class="ca-vr_tooltip_bg"><path stroke="black" stroke-width="' +
        this.options.strokeWidth +
        '" /></svg>'
    );
    if (this.options.color) { this.tooltipBg.find('path').attr('fill', this.options.color); }
    this.div.append(this.tooltipBg);

    this.setText(this.options.label);
  }

  setBackgroundColor (color) {
    this.options.color = color;
    this.tooltipBg.find('path').attr('fill', this.options.color);
  }

  setTextColor (color) {
    this.options.textColor = color;
    this.tooltipLabel.css('color', this.options.textColor);
  }

  setText (text) {
    this.options.label = text;

    this.tooltipLabel.text(text);
    if (!text || text.length < 1) {
      this.div.hide();
      return;
    }

    this.div.show();
    this.layout();
  }

  setPosition (position) {
    this.options.position = position;
    this.layout();
  }

  layout () {
    if (!this.options.label) return;
    const pos = this.options.position;
    const isLR = pos === 'left' || pos === 'right';
    const isTB = pos === 'top' || pos === 'bottom';
    const tipWidth = this.options.tip.width;
    const tipWidthHalf = tipWidth / 2;
    const tipHeight = this.options.tip.height;
    const corner = this.options.corner;
    const labelWidth = Math.max(
      corner * 2,
      Math.floor(this.tooltipLabel.outerWidth())
    );
    const labelHeight = Math.max(
      corner * 2,
      Math.floor(this.tooltipLabel.outerHeight())
    );
    if (labelWidth < 0 || labelHeight < 0) return;

    const innerWidth = labelWidth - corner * 2;
    const innerHeight = labelHeight - corner * 2;
    const width = labelWidth + (isLR ? tipHeight : 0);
    const height = labelHeight + (isTB ? tipHeight : 0);
    const lineToTipV = Math.max(0, innerHeight / 2 - tipWidth / 2);
    const lineToTipH = Math.max(0, innerWidth / 2 - tipWidth / 2);
    const stroke = this.options.strokeWidth;
    const halfStroke = stroke / 2;

    this.div.outerWidth(width);
    this.div.outerHeight(height);
    if (pos === 'right') {
      this.tooltipLabel.css('margin', 0);
      this.tooltipLabel.css('margin-left', tipHeight);
    } else if (pos === 'left') {
      this.tooltipLabel.css('margin', 0);
      this.tooltipLabel.css('margin-right', tipHeight);
    } else if (pos === 'bottom') {
      this.tooltipLabel.css('margin', 0);
      this.tooltipLabel.css('margin-top', tipHeight);
    } else if (pos === 'top') {
      this.tooltipLabel.css('margin', 0);
      this.tooltipLabel.css('margin-bottom', tipHeight);
    }

    this.tooltipBg.attr('width', width);
    this.tooltipBg.attr('height', height);

    this.tooltipBg.attr(
      'viewBox',
      '-' +
        halfStroke +
        ',-' +
        halfStroke +
        ',' +
        (width + stroke) +
        ',' +
        (height + stroke)
    );

    // Top left
    let path;
    path =
      'M' +
      (corner + (pos === 'right' ? tipHeight : 0)) +
      ',' +
      (pos === 'bottom' ? tipHeight : 0);

    // Top
    if (pos === 'bottom') {
      if (this.options.tip.type === 'arrow') {
        path +=
          ' h' +
          lineToTipH +
          ' L' +
          width / 2 +
          ',0 L' +
          (width / 2 + tipWidthHalf) +
          ',' +
          tipHeight +
          ' h' +
          lineToTipH;
      } else if (this.options.tip.type === 'line') {
        path +=
          ' h' +
          lineToTipH +
          ' v-' +
          tipHeight +
          ' h' +
          tipWidth +
          ' v' +
          tipHeight +
          ' h' +
          lineToTipH;
      }
    } else path += ' h' + innerWidth;

    // Top right
    path += ' a' + corner + ',' + corner + ' 0 0 1 ' + corner + ',' + corner;

    // Right
    if (pos === 'left') {
      if (this.options.tip.type === 'arrow') {
        path +=
          ' v' +
          lineToTipV +
          ' L' +
          width +
          ',' +
          height / 2 +
          ' L' +
          (width - tipHeight) +
          ',' +
          (height / 2 + tipWidthHalf) +
          ' v' +
          lineToTipV;
      } else if (this.options.tip.type === 'line') {
        path +=
          ' v' +
          lineToTipV +
          ' h' +
          tipHeight +
          ' v' +
          tipWidth +
          ' h-' +
          tipHeight +
          ' v' +
          lineToTipV;
      }
    } else path += ' v' + innerHeight;

    // Bottom right
    path += ' a' + corner + ',' + corner + ' 0 0 1 -' + corner + ',' + corner;

    // Bottom
    if (pos === 'top') {
      if (this.options.tip.type === 'arrow') {
        path +=
          ' h-' +
          lineToTipH +
          ' L' +
          width / 2 +
          ',' +
          height +
          ' L' +
          (width / 2 - tipWidthHalf) +
          ',' +
          (height - tipHeight) +
          ' h-' +
          lineToTipH;
      } else if (this.options.tip.type === 'line') {
        path +=
          ' h-' +
          lineToTipH +
          ' v' +
          tipHeight +
          ' h-' +
          tipWidth +
          ' v-' +
          tipHeight +
          ' h-' +
          lineToTipH;
      }
    } else path += ' h-' + innerWidth;

    // Bottom left
    path += ' a' + corner + ',' + corner + ' 0 0 1 -' + corner + ',-' + corner;

    // Left
    if (pos === 'right') {
      if (this.options.tip.type === 'arrow') {
        path +=
          ' v-' +
          lineToTipV +
          ' L0,' +
          height / 2 +
          ' L' +
          tipHeight +
          ',' +
          (lineToTipV + corner) +
          ' v-' +
          lineToTipV;
      } else if (this.options.tip.type === 'line') {
        path +=
          ' v-' +
          lineToTipV +
          ' h-' +
          tipHeight +
          ' v-' +
          tipWidth +
          ' h' +
          tipHeight +
          ' v-' +
          lineToTipV;
      }
    } else path += ' v-' + innerHeight;

    // Top left corner
    path +=
      ' a' + corner + ',' + corner + ' 0 0 1 ' + corner + ',-' + corner + ' z';

    this.tooltipBg.find('path').attr('d', path);
  }
}
